import { z } from 'my-zod'

export const MarketEnum = z.enum(['arizona', 'utah', 'nevada', 'colorado', 'midwest', 'national']).setEnumLabels({
  arizona: 'Arizona',
  utah: 'Utah',
  nevada: 'Nevada',
  colorado: 'Colorado',
  midwest: 'Midwest',
  national: 'National'
})

export const Markets = MarketEnum.Values
export type Market = z.infer<typeof MarketEnum>
export const MarketOptions = Object.values(Markets)
export const MarketLabels = MarketEnum.enumLabels
